var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "newKeyWordStatisticsDetail-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "70%",
            "close-on-click-modal": false,
            "destroy-on-close": "",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close
          }
        },
        [
          _c("div", { staticClass: "staff-chat-supervise-search" }, [
            _c(
              "div",
              { staticClass: "serach-left" },
              [
                _c("el-date-picker", {
                  staticStyle: { width: "240px", "margin-right": "10px" },
                  attrs: {
                    size: "mini",
                    type: "daterange",
                    editable: false,
                    "value-format": "yyyy-MM-dd",
                    "range-separator": "~",
                    "start-placeholder": "开始时间",
                    "end-placeholder": "结束时间",
                    "picker-options": _vm.pickerOptions,
                    clearable: false
                  },
                  on: { change: _vm.handleTime },
                  model: {
                    value: _vm.filterParams.timeArray,
                    callback: function($$v) {
                      _vm.$set(_vm.filterParams, "timeArray", $$v)
                    },
                    expression: "filterParams.timeArray"
                  }
                }),
                _c("el-input", {
                  staticStyle: { width: "190px", "margin-right": "10px" },
                  attrs: {
                    size: "mini",
                    "suffix-icon": "el-icon-search",
                    placeholder: "关键词",
                    clearable: ""
                  },
                  on: {
                    blur: _vm.handleConsultList,
                    clear: _vm.handleConsultList
                  },
                  model: {
                    value: _vm.filterParams.wordName,
                    callback: function($$v) {
                      _vm.$set(_vm.filterParams, "wordName", $$v)
                    },
                    expression: "filterParams.wordName"
                  }
                }),
                _c("el-input", {
                  staticStyle: { width: "190px", "margin-right": "10px" },
                  attrs: {
                    size: "mini",
                    "suffix-icon": "el-icon-search",
                    placeholder: "姓名",
                    clearable: ""
                  },
                  on: {
                    blur: _vm.handleConsultList,
                    clear: _vm.handleConsultList
                  },
                  model: {
                    value: _vm.filterParams.userName,
                    callback: function($$v) {
                      _vm.$set(_vm.filterParams, "userName", $$v)
                    },
                    expression: "filterParams.userName"
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "el-table",
            {
              ref: "cusChatTable",
              staticStyle: { "font-size": "13px" },
              attrs: {
                size: "small",
                data: _vm.tableData,
                fit: "",
                "highlight-current-row": "",
                "header-cell-style": { background: "#F9F9F9" },
                height: "60vh",
                "empty-text": "暂无关键词数据"
              }
            },
            [
              _vm.isNewEdition
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "关键词组",
                      "show-overflow-tooltip": "",
                      "min-width": "150",
                      prop: "wordTypeName"
                    }
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "wordName",
                  label: "关键词",
                  "show-overflow-tooltip": "",
                  "min-width": "150"
                }
              }),
              !_vm.isNewEdition
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "归属分类",
                      "min-width": "150",
                      prop: "wordTypeName"
                    }
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  align: "center",
                  label: "出现时间",
                  "min-width": "120"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "hitCount",
                  align: "center",
                  label: "聊天内容",
                  "min-width": "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "tag-wrap" }, [
                          _c(
                            "span",
                            {
                              staticClass: "more-users",
                              on: {
                                click: function($event) {
                                  return _vm.handleChactClick(scope.row, 2)
                                }
                              }
                            },
                            [_vm._v("查看")]
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "externalName",
                  align: "center",
                  label: "涉及客户",
                  "show-overflow-tooltip": "",
                  "min-width": "80"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.isNewEdition ? "涉及员工" : "归属部门",
                  "min-width": "250",
                  align: "center",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.isNewEdition
                                  ? scope.row.userName
                                  : scope.row.departName
                              ) +
                              " "
                          )
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c("Pagination", {
            attrs: { childMsg: _vm.pageParms, pageSizes: _vm.pageSizes },
            on: { callBack: _vm.callBack }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "chat-content-dialog",
          attrs: {
            visible: _vm.dialogChatVisible,
            "close-on-click-modal": false,
            "modal-append-to-body": false,
            "append-to-body": "",
            width: "600px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogChatVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "content-container" },
            [_c("SenWordChatCommon", { ref: "SenWordChatCommon" })],
            1
          )
        ]
      ),
      _vm.NewKeyWordStatisticsDetailChatContentShow
        ? _c("NewKeyWordStatisticsDetailChatContent", {
            ref: "NewKeyWordStatisticsDetailChatContentRef",
            on: { chatContentClose: _vm.chatContentClose }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }